import { useState, useRef } from 'react';
import { Button, P, Stack } from '@workramp/ui';
import { guid } from '~/common';
import UploadWithProgress from '~/components/common/upload-with-progress';
import AcademiesApi from '~/agent/academies';
import UploadedFontFile from './UploadedFontFile';

const FONT_FILE = 'font_file';

interface FontUploadProps {
  uploadCompletedCallback: () => void;
  onCustomFontDelete: () => void;
  academyId: number;
  customFontFile: string;
}

export default function FontUpload({
  uploadCompletedCallback,
  academyId,
  customFontFile,
  onCustomFontDelete,
}: FontUploadProps) {
  const [uploadData, setUploadData] = useState(null);
  const inputRef = useRef(null);

  const onFileUpload = (e) => {
    e.preventDefault();
    const [file] = e.target.files;

    const data = new FormData();
    data.append(FONT_FILE, file);
    if (file && data) {
      const fontFileInfo = {
        id: guid(),
        data,
        file_name: file.name,
      };
      setUploadData(fontFileInfo);
    }
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  const removeCallback = async () => {
    await AcademiesApi.deleteCustomFontFile(academyId);
    uploadCompletedCallback();
    onCustomFontDelete();
  };

  const handleUploadEndState = () => {
    setUploadData(null);
    uploadCompletedCallback();
  };

  return (
    <Stack size={2}>
      <P size={1}>Files Accepted: .woff, .woff2</P>
      {customFontFile ? (
        <UploadedFontFile removeCallback={removeCallback} customFontFile={customFontFile} />
      ) : (
        <>
          <input accept=".woff, .woff2" type="file" ref={inputRef} onChange={onFileUpload} hidden />
          <Button variant="outline" color="secondary" onPress={handleClick}>
            Upload Font
            {uploadData && (
              <UploadWithProgress
                data={uploadData.data}
                url={`/api/academies/${academyId}/custom_font_file`}
                method="POST"
                uploadCompleted={handleUploadEndState}
                uploadFailed={handleUploadEndState}
                onlyShowProgressBar
              />
            )}
          </Button>
        </>
      )}
    </Stack>
  );
}
